import { createFocusTrap } from "focus-trap"

export default function blogMobileModal() {
  const filtersModal = document.querySelector("[data-mobile-filters]")
  const openButton = document.querySelector("[data-open-filters]")
  const closeButton = document.querySelector("[data-close-filters]")
  const viewResultsButton = document.querySelector("[data-view-results]")

  let trap

  if (openButton && filtersModal && closeButton) {
    openButton.addEventListener("click", () => {
      filtersModal.classList.add("active")
      document.body.style.overflow = "hidden"
      closeButton.focus()

      const trapElement = filtersModal.querySelector(".blog-filters-mobile-wrapper__panel")
      trap = createFocusTrap(trapElement, {
        escapeDeactivates: true,
        onDeactivate: () => {
          filtersModal.classList.remove("active")
          document.body.style.overflow = ""
          openButton.focus()
        },
      })

      trap.activate()
    })
  }

  if (closeButton && filtersModal) {
    closeButton.addEventListener("click", () => {
      if (trap) {
        trap.deactivate()
      }
    })
  }

  if (viewResultsButton && filtersModal) {
    viewResultsButton.addEventListener("click", () => {
      if (trap) {
        trap.deactivate()
      }
    })
  }
}
